import { Dropdown, Input } from "reactstrap";
import styled from "styled-components";

export const FilterTitle = styled.div`
	color: #262626;
	font-family: "Inter";
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 150%;
`;

export const CheckBox = styled(Input)`
	width: 16px;
	height: 16px;

	:hover {
		cursor: pointer;
	}

	&:checked {
		background-color: #333333;
		border-color: #333333;
	}
	&:focus {
		box-shadow: none;
		border-color: ${(props) => (props.disabled === "" ? "#333333" : "#c4c4c4")};
	}
`;

export const CustomDropdown = styled(Dropdown)`
	.dropdown-menu.show {
		padding: 0px;
	}
`;

export const FiltersContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 16px;
	padding: 24px 16px 24px 16px;
`;

export const ListItemsContainer = styled.div`
	height: 480px;
	padding: 0px 16px 16px 16px;
`;

export const ListItem = styled.div`
	width: 100%;
	padding: 16px;
	display: flex;
	align-items: center;
	gap: 8px;
	border-top: 1px solid #d9d9d9;
	cursor: pointer;
`;

export const EmptyList = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 20px;
`;

export const EmptyIconContainer = styled.div`
	svg {
		width: 68px;
		height: 68px;
	}
	path {
		fill: #262626;
	}
`;
